import type { NewDateRangeInfo } from '../../types/dateRange.types';
import { formatToDefaultFormat } from './formatToDefaultFormat';
import { getAllRanges } from './getAllRanges';

export const getNewDateRangeInfo = (dateRangeInfo: Partial<NewDateRangeInfo>): NewDateRangeInfo => {
  const allDefaultRanges = getAllRanges();
  const defaultRange = dateRangeInfo.defaultRange || 'custom';

  if (defaultRange === 'custom') {
    const { dateRange } = dateRangeInfo;
    const startDate = dateRange?.start_date || formatToDefaultFormat(new Date());
    const endDate = dateRange?.end_date || formatToDefaultFormat(new Date());

    return {
      dateRange: {
        start_date: startDate,
        end_date: endDate,
      },
      defaultRange,
    };
  }

  const calculatedDateRange = allDefaultRanges.find((range) => range.type === defaultRange)?.getValue();
  const startDate = formatToDefaultFormat((calculatedDateRange && calculatedDateRange[0]) || new Date());
  const endDate = formatToDefaultFormat((calculatedDateRange && calculatedDateRange[1]) || new Date());

  return {
    dateRange: {
      start_date: startDate,
      end_date: endDate,
    },
    defaultRange,
  };
};
